/**
 * Simple hash function for strings (djb2)
 */
export function hashString(str) {
	let hash = 5381;

	for (let i = 0; i < str.length; i++) {
		hash = ((hash << 5) + hash) + str.charCodeAt(i); // hash * 33 + c
	}

	return hash >>> 0; // Ensure unsigned
}

/**
 * Escape RegExp special characters in a string.
 */
export function escapeRegExp(string) {
	return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Split HTML into chunks of text and tags, similar to wp_html_split.
 */
export function splitHtml(html) {
	// Regex: match tags or comments
	const regex = /(<[^>]+>|<!--[\s\S]*?-->)/g;

	return html.split(regex);
}
